import { run } from "./engine/app"
import configuration from "./configuration"

/* Import runtime env pattern for create separated bundle */
import "./runtime.env-pattern.jsoff"

import "./automatedTestUtils"

const runApp = () => {
  run(configuration)
}

export default runApp
